import axios from '../../axios'
import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { action, makeObservable, observable, runInAction } from 'mobx'
import { toast } from 'react-toastify'
import { ISignupUsersRequest, SignupInvitation } from './types'
import history from 'history.js'
import { accessManagementBaseURL } from 'config'
export class SignupStore {
  loadingList: boolean = false
  deleting: boolean = false
  list: SignupInvitation[] = []
  entries: {
    [key: string]: SignupInvitation
  } = {}
  totalPages: number = 0
  totalElements: number = 0
  cancelTokenSource = () => {}

  constructor() {
    makeObservable(this, {
      loadingList: observable,
      deleting: observable,
      list: observable,
      entries: observable,
      totalPages: observable,
      totalElements: observable,
      getData: action,
      setList: action,
      reset: action,
      clearList: action,
      removeFromList: action,
      setLoadingList: action,
    })
  }

  reset = () => {
    this.clearList()
    this.deleting = false
    this.entries = {}
    this.cancelTokenSource = () => {}
  }

  clearList = () => {
    this.loadingList = false
    this.list = []
    this.totalPages = 0
    this.totalElements = 0
  }

  setLoadingList = (value: boolean) => {
    this.loadingList = value
  }

  removeFromList = (id: number) => {
    this.list = this.list.filter((item) => item.id !== id)
  }

  generateSignupInvitation = async (data: object) => {
    return await axios
      .post('/management/api/v1/signup/invitation', data)
      .then((response) => {
        toast.success('Created successfully')
        return response
      })
  }

  resendSignupInvitation = async (id: number) => {
    return await axios
      .put('/management/api/v1/signup/' + id)
      .then((response: AxiosResponse<SignupInvitation>) => {
        toast.success('Resent Invitation successfully')
        this.setList(response.data)
        return response
      })
  }

  delete = async (id: number) => {
    this.deleting = true
    await axios
      .delete('/management/api/v1/signup/' + id)
      .then(({ data }) => {
        toast.success('Deleted successfully')
        this.removeFromList(id)
      })
      .finally(() => {
        this.deleting = false
      })
  }

  getData = (filters: any = {}) => {
    if (typeof this.cancelTokenSource == 'function') {
      // this.cancelTokenSource()
    }
    const cancelTokenSource = Axios.CancelToken.source()

    const params: any = {
      ...filters,
      criteria: filters.searchValue
    }
    delete params.searchValue

    this.setLoadingList(true)

    const config: AxiosRequestConfig = {
      cancelToken: cancelTokenSource.token,
      params,
    }
    axios
      .get(`/management/api/v1/signup`, config)
      .then(({ data }) => {
        if (data?.content) {
          runInAction(() => {
            this.list = data.content
            this.totalPages = data.totalPages
            this.totalElements = data.totalElements
            this.list.forEach((item) => (this.entries[`${item.id}`] = item))
          })
        }
      })
      .catch(() => {
        this.clearList()
      })
      .finally(() => {
        this.setLoadingList(false)
      })

    this.cancelTokenSource = cancelTokenSource.cancel
  }

  setList = (signup: SignupInvitation) => {
    const index = this.list.findIndex((item: SignupInvitation) => item.id === signup.id)
    if (index !== -1) {
      this.list[index] = signup
    }
    this.entries[`${signup.id}`] = signup
  }

  validateSignupToken = async (token: string) => {
    const headers = {
      'Authorization': `Bearer ${token}`
    }
   
    return await Axios
    .post(`${accessManagementBaseURL}management/api/v1/signup/invitation/token/validate`,null, {headers: headers})
    .then((response) => {
      console.log(JSON.stringify(response));
      if(response.status === 200) {
        return response.data;
      } else {
        history.push('/signin');
      }
    }).catch((error) => {
      toast.error('Sorry, but an unexpected error has occurred. Our team is working to resolve it as quickly as possible.');
      history.push('/signin');
    });
  }

  createUser = async (data: ISignupUsersRequest, token: string) => {
    const headers = {
      'Authorization': `Bearer ${token}`
    }
    return await Axios
    .post(`${accessManagementBaseURL}management/api/v1/signup`,data, {headers: headers})
    .then((response) => {
      if(response.status === 200) {
        toast.success('Please login with your new account');
        return;
      }
  });
  };

}

export const signupStore = new SignupStore();
